import React, { useEffect } from 'react';
import { useTimer } from '../../../hooks/useTimer/index';
import { Link } from '../../Link/index';
require("../SmsForm.css");
var styles = {
  "Root": "SmsForm-module-Root_6LR",
  "Header": "SmsForm-module-Header_2gE",
  "Headline": "SmsForm-module-Headline_7ca",
  "Description": "SmsForm-module-Description_1ET",
  "Footer": "SmsForm-module-Footer_2ZP",
  "Error": "SmsForm-module-Error_3I1",
  "Addons": "SmsForm-module-Addons_U-3",
  "Preloader": "SmsForm-module-Preloader_30w"
};
export const UpdateCode = ({
  input,
  onUpdateSmsCode
}) => {
  const {
    seconds,
    minutes,
    start,
    restart
  } = useTimer();
  useEffect(() => {
    start();
  }, [start]);
  const handleUpdateCode = () => {
    onUpdateSmsCode();
    restart();
    /**
     * TODO
     * Не работает фокус первого инпута
     * PinInput требует доработки
     * Сейчас фокусируется последний инпут
     */
    if (input.current !== null) {
      input.current.focus();
    }
  };
  if (minutes === 0 && seconds === 0) {
    return /*#__PURE__*/React.createElement(Link, {
      tag: "button",
      onClick: handleUpdateCode
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: 600
      }
    }, "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E"));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Description
  }, "\u041D\u043E\u0432\u044B\u0439 \u043A\u043E\u0434 \u0447\u0435\u0440\u0435\u0437 ", `${minutes}:${seconds}`);
};
if (process.env.NODE_ENV !== 'production') {
  UpdateCode.displayName = 'UpdateCode';
}